
import TableList from "@components/templates/tablelist";
import { HttpOversizeList, HttpDeleteOversizeOne } from "@/service/fedex";
import { mapGetters } from "vuex";
// import mixin from "../mixin";
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpOversizeList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "query":
                    var url = this.$router.resolve({
                        name: "fedexOversizeUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "edit":
                    this.$router.push({
                        name: 'fedexOversizeUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "add":
                    this.$router.push({
                        name: 'fedexOversizeUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params },
                        title: "删除",
                        ajaxRequest: HttpDeleteOversizeOne
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row
            return [{
                label: '查看详情',
                show: true,
                params: id,
                operate: 'query'
            },
            {
                label: '编辑',
                show: true,
                params: id,
                operate: 'edit'
            },
            {
                label: '删除',
                show: true,
                params: id,
                operate: 'delete'
            }
            ]
        }
    },
    computed: {
        // ...mapGetters('dictionary', ['getWarehouseAllList', 'getOrgList']),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "规则名称",
                    tag: 'vInput',
                    key: 'EQ_ruleName',
                    show: true,
                },
                {
                    label: "创建日期",
                    tag: 'vDatepicker',
                    style: "width:250px",
                    key: 'BT_createdAt',
                    show: true,
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                },
            ]
        },
        columns() {
            return [
                {
                    title: '操作',
                    maxWidth: 90,
                    render: this.getOperateNodes
                }, {
                    title: '规则名称',
                    key: 'ruleName',
                },
                {
                    title: '规则公式',
                    key: 'ruleRangeFormula',
                },
                {
                    title: '创建人',
                    key: 'createdName',
                },
                {
                    title: '创建时间',
                    key: 'createdAt',
                },
            ];
        },

    },

};
